import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

import * as schoolsetup from '../school.forms';

import { ProjectmanagementService } from '../../../../../projectmanagement/src/app/service/projectmanagement.service';
import { SchoolManagementService } from '../../service/schoolmanagement.service';

import { MyErrorHandler } from '../../../../../projectmanagement/src/app/errorhandler/errorhandler';
import { Grade, Year, Class, Subject } from '../../model/school.model';

declare var jQuery;

@Component({
  selector: 'app-ctl-gradesubject-form',
  templateUrl: './ctl.school.gradesubject.component.html',
  styleUrls: ['./ctl.school.gradesubject.component.css'],
  providers: [ProjectmanagementService, SchoolManagementService]
})


export class AddGradeSubjectComponent implements OnInit {
  gradeList = [];
  classList = [];
  gradeListData = {};
  subjectListData = {};
  subjectList = [];
  subjectsAddedList = [];
  gradeClassForm: FormGroup;
  gradeDataList: Grade[] = [];
  schoolDetails:any =[];
  nextBtnClicked = false;
  grade_id: string;
  grade: string;
  loaded = false;
  @Input() project_id: string;
  @Input() school_id: string;
  @Input() refresh: boolean;
  @Input() inputGradeSubjectListTemp: any;

  @Output() evOpenGradeSubject: EventEmitter<any> = new EventEmitter();
  textDir:any;
  constructor(
    private _fb: FormBuilder,
    private projectService: ProjectmanagementService,
    private schoolService: SchoolManagementService,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir')
   }

  ngOnInit() {

    // jQuery('[data-toggle="tooltip"]').tooltip();
    this.subjectsAddedList = [];
    this.nextBtnClicked = false;
    this.getSubjectList();
    this.getGradeSubjectList();
    /*this.gradeClassForm = this._fb.group({
      'gradeArray': this._fb.array([])
    });*/
    // this.addGradesToForm();
  }
  // ngOnChanges(){
  //   console.log('Kajal2234');
  //   console.log(this.refresh);
  // }
  ngDoCheck() {
    if (this.refresh === true) {
      this.refresh = false;
      this.getSubjectList();
      this.getGradeSubjectList();
      // this.addGradesToForm();
      /*this.gradeClassForm = this._fb.group({
        'gradeArray': this._fb.array([])
      });*/
    }
  }

  ngAfterViewInit() {
    // this.getSubjectList();
    // this.getGradeSubjectList();
    // this.addGradesToForm();
    /*this.gradeClassForm = this._fb.group({
      'gradeArray': this._fb.array([])
    });*/
  }

  getSchoolDetails(){
    this.schoolService.detail(this.school_id).subscribe(
      (response) => {
        this.schoolDetails = response;
        console.log('school details jani  assign subject:' + JSON.stringify(this.schoolDetails));
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }
  getSubjectList() {
    if (this.project_id) {
      this.projectService.listProjectSubject(this.project_id).subscribe(
        (response) => {
          this.subjectList = response;
          console.log('Subject List jani :' + JSON.stringify(this.subjectList));
          return true;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        //console.log('COMPLETED');
        }
      );
    }
  }


  addGradesToForm() {

    const subjectForm = this._fb.array([]);
    this.gradeClassForm = this._fb.group({
      'gradeArray': this._fb.array([])
    });

    const gradeControl = <FormArray>this.gradeClassForm.controls['gradeArray'];
    this.gradeDataList = this.gradeList;
    if (this.gradeDataList && this.gradeDataList.length) {
      for (const grade of this.gradeDataList) {
        if (grade.name) {
          if (grade.subjects && grade.subjects.length) {
            gradeControl.push(this.patchGrade(grade, grade.subjects));
            // const subjectctrl = <FormArray>gradeControl.controls['subjects'];
            /*
            const subjectctrl = [];
            grade.subjects.forEach(item => {
              console.log('first element ' + JSON.stringify(item));
              subjectctrl.push(this.patchSubject(item));
              console.log('first element added');
            });
            if (subjectctrl.length) {
              gradeControl.push(this.patchGrade(grade, subjectctrl));
            } else {
              gradeControl.push(this.patchGrade(grade, ''));
            }
            */
          } else {
            gradeControl.push(this.patchGrade(grade, ''));
          }
        }
      }
    }
    this.loaded = true;

    //console.log('grade Subject form ======' + JSON.stringify(this.gradeClassForm.value));

  }

  patchGrade(grade, subjects) {
    return this._fb.group({
      grade: [grade],
      subjects: [subjects]
    });
  }
  patchSubject(subject) {
    return this._fb.group({
      subject: [subject]
    });
  }

  getGradeSubjectList() {
    if(Object.keys(this.inputGradeSubjectListTemp).length){
      this.schoolService.listClass(this.school_id).subscribe(
        (response) => {
          const classList = response;
          this.getSchoolDetails();
          console.log("classList >>> "+JSON.stringify(response))
          for (const myclass of classList) {
            if ( myclass.grade && this.gradeList && this.gradeList.map(function(e) { return e.name; }).indexOf(myclass.grade.name) === -1) {
              this.gradeList.push(myclass.grade);
            }
          }
          let i = 0;
          
          for (const grade of this.gradeList) {
            this.gradeList[i].classes = [];
            this.gradeList[i].subjects = [];
            let indx = 0;
            classList.forEach(item => {
              if(item.grade && this.inputGradeSubjectListTemp.find(x => x._id === item.grade._id) && grade._id === item.grade._id){
                const ind = this.inputGradeSubjectListTemp.findIndex(x => x._id === item.grade._id);
                this.gradeList[i].subjects = this.inputGradeSubjectListTemp[ind].subjects;
                this.subjectsAddedList = this.inputGradeSubjectListTemp[ind].subjects;
                delete item.subjects;
                delete item.grade;
                this.gradeList[i].classes.push(this.inputGradeSubjectListTemp[ind].classes[indx]);
                indx++;
              }
              else if (item.grade && grade._id === item.grade._id) {
                if (!this.gradeList[i].subjects.length) {
                  this.gradeList[i].subjects = item.subjects;
                  this.subjectsAddedList = item.subjects;
                }
                delete item.subjects;
                delete item.grade;
                this.gradeList[i].classes.push(item);
              }
              
            });
            i++;
          }
          // this.addGradesToForm();
          this.loaded = true;
          return true;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        //console.log('COMPLETED');
        }
      );
      // console.log('Modified Grade List');
      // console.log(this.gradeList);
    }else{
      this.schoolService.listClass(this.school_id).subscribe(
        (response) => {
          //console.log('Grade List :' + JSON.stringify(response));
          const classList = response;
          this.getSchoolDetails();
          for (const myclass of classList) {
            if ( myclass.grade && this.gradeList && this.gradeList.map(function(e) { return e.name; }).indexOf(myclass.grade.name) === -1) {
              this.gradeList.push(myclass.grade);
            }
          }
  
          let i = 0;
          for (const grade of this.gradeList) {
            this.gradeList[i].classes = [];
            this.gradeList[i].subjects = [];
            classList.forEach(item => {
              if (item.grade && grade._id === item.grade._id) {
                if (!this.gradeList[i].subjects.length) {
                  this.gradeList[i].subjects = item.subjects;
                  this.subjectsAddedList = item.subjects;
                }
                /*if (
                    this.classList.map(function(e) { return e.name; }).indexOf(item.name) === -1 &&
                    this.classList.map(function(e) { return e.grade.name; }).indexOf(item.grade.name) === -1
                ) {*/
                  delete item.subjects;
                  delete item.grade;
                  this.gradeList[i].classes.push(item);
                  //console.log("gradeSubject List JANI >>>>> "+JSON.stringify(this.gradeList))
                /*}*/
              }
            });
            i++;
          }
          // this.addGradesToForm();
          this.loaded = true;
          return true;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        //console.log('COMPLETED');
        }
      );
      // console.log('Grade List');
      // console.log(this.gradeList);
    }
  }

  isSubjectChecked(grade, subject, event) {
    const i = this.gradeDataList.findIndex(x => x.name === grade.name);
      if (i === -1) {
          return;
      } else {
        const j = this.gradeDataList[i].subjects.findIndex(y => y.name === subject.name);
        if (j > 0) {
          return event.target.checked;
        }
        return;
      }
  }

  onSubjectChange(grade, subject, event) {

    const i = this.gradeDataList.findIndex(x => x.name === grade.name);
    if (event.target.checked) { /* Selected */
      // Add a new control in the arrayForm
      if (i === -1) {
        grade.subjects = [event.target.value];
        this.gradeDataList.push(grade);
      } else {
        this.gradeDataList[i]._id = grade._id;
        this.gradeDataList[i].subjects.push(event.target.value);
      }
    } else { /* unselected */
      // find the unselected element
      if (i) {
        this.gradeDataList[i].subjects.push(event.target.value);

        let j = 0;
        this.gradeDataList[i].subjects.forEach( item => {
          if (item._id === event.target.value) {
            // Remove the unselected element from the arrayForm
            this.gradeDataList[i].subjects.splice(j, 1);
            return;
          }
          j++;
        });
      }
    }
    // check data list and update
  }

  submitGradeSubject() {
    if (this.grade_id) {
      //this.updateGradeSubject();
    } else {
      this.addGradeSubject();
    }
  }

  addGradeSubject() {
    //
    const data = [];
    //console.log('Class subject form ======' + JSON.stringify(this.gradeDataList));

    this.gradeDataList.forEach(item => {
      const gradeSubject = {'grade_id': item._id, 'subjects': item.subjects};
      data.push(gradeSubject);
    });


    if (data && data.length) {
      //console.log('class subject data ======' + JSON.stringify(data));
      this.schoolService.addGradeSubject(data, this.school_id).subscribe(
        (response) => {
          //console.log('Class Subject Added :' + JSON.stringify(response));
          this.getGradeSubjectList();
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        console.log('COMPLETED');
        }
      );
    } else {
      console.log('nothing to add');
    }
    // error/warning msg on screen
  }

  updateGradeSubject() {
      //
    let data = {};

    const tmp = this.gradeDataList;

    if (tmp && tmp.length) {
      const i = this.gradeDataList.findIndex(x => x._id === this.grade_id);
      data = {'grade_id': tmp[i]._id, 'subjects': tmp[i].subjects};
    }

    if (data) {
      //console.log('grade Subject data ======' + JSON.stringify(data));
      /*
      this.schoolService.updateGradeClass(this.grade_id , data, this.school_id).subscribe(
        (response) => {
          console.log('Grade Subject Updated :' + JSON.stringify(response));
          this.getGradeSubjectList();
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandler = new ErrorHandler(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
        console.log('COMPLETED');
        }
      );
      */
    }
  }

  currentSelectedGrade(grade) {
    //
    this.evOpenGradeSubject.emit(grade);
  }

  readOnly(grade: string) {
    //
  }

   ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
   }

}
